export default __webpack_public_path__ + "135c44e2f309b35f9d482f889e91c0bc.png";